module.exports = __webpack_public_path__ + "img/little-symmetry-warning.4109d3d1.svg";